export const provinceVatCodeMap = {
  AB: "XG",
  BC: "XG",
  MB: "XG",
  NB: "15",
  NL: "15",
  NT: "XG",
  NS: "14",
  NU: "XG",
  ON: "RC",
  PE: "15",
  QC: "XG",
  SK: "XG",
  YT: "XG",
  "NT/NU": "XG",
} as const;
